import React, { createContext, useContext, useState, useEffect } from 'react';
import { downloadData } from 'aws-amplify/storage';

const DeviceDataContext = createContext();

export function DeviceDataProvider({ children }) {
  const [devicesData, setDevicesData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function getDeviceData() {
      try {
        const result = await downloadData({
          path: 'static/devices.json',
          options: { bucket: 'static' }
        }).result;
        if (result && result.body) {
          const text = await result.body.text();
          setDevicesData(JSON.parse(text));
        } else {
          setDevicesData(null);
        }
      } catch (error) {
        setDevicesData(null);
      } finally {
        setLoading(false);
      }
    }
    getDeviceData();
  }, []);

  return (
    <DeviceDataContext.Provider value={{ devicesData, loading }}>
      {children}
    </DeviceDataContext.Provider>
  );
}

export function useDeviceData() {
  return useContext(DeviceDataContext);
}
